import { render, staticRenderFns } from "./InformationCreate.vue?vue&type=template&id=7e49937b&"
import script from "./InformationCreate.vue?vue&type=script&lang=js&"
export * from "./InformationCreate.vue?vue&type=script&lang=js&"
import style0 from "./InformationCreate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports